import { toast } from "../Toast/Toast";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  Button,
  Header,
  Icon,
  Modal,
  ModalContent,
  ModalActions,
  Form,
  Checkbox,
  Message,
} from "semantic-ui-react";
import { sendAssetsToStartprintAPI } from "services/apiMiddleware";

function SendToStartPrintModal({ open, setModalOpen, selectedAssets, setSelectedAssets, sender }) {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const [selectedResolutions, setSelectedResolutions] = useState([]);
  const [submitList, setSubmitList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPantone, setIsPantone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const resolutionOptions = [
    { value: "120x180cm", label: "CITYLIGHT" },
    { value: "120x175cm", label: "SCROLL" },
    { value: "600x300cm", label: "BILLBOARD" },
    { value: "828x428cm", label: "BACKLIGHT 8x4" },
    { value: "420x820cm", label: "BACKLIGHT 4x8" },
    { value: "680x380cm", label: "VINYL 6x3" },
  ];

  const handleClose = () => {
    setCurrentIndex(0);
    setSelectedResolutions([]);
    setSubmitList([]);
    setModalOpen(false);
  };

  const handleSubmit = async (asset) => {
    const assets = [
      ...submitList,
      {
        asset_path: asset.media,
        is_panton: isPantone,
        file_sizes: selectedResolutions,
      },
    ];
    setIsLoading(true);
    const { errorMessage } = await sendAssetsToStartprintAPI(
      asset.campaign.id,
      asset.campaign.name,
      asset.campaign.orderlineID,
      sender.username,
      assets
    );
    setCurrentIndex(0);
    setSelectedResolutions([]);
    setIsPantone(false);
    setSubmitList([]);
    setModalOpen(false);
    if (errorMessage) {
      toast("error", errorMessage);
    } else {
      toast(
        undefined,
        t("campaign_display_asset_sent_successful", { printServiceName: "StartPrint API" })
      );
    }
    setIsLoading(false);
    dispatch.assets.loadCampaignAssets(asset.campaign.id);
    setSelectedAssets([]);
  };

  const handleNext = (asset) => {
    setSubmitList([
      ...submitList,
      {
        asset_path: asset.media,
        is_panton: isPantone,
        file_sizes: selectedResolutions,
      },
    ]);
    setSelectedResolutions([]);
    setCurrentIndex(currentIndex + 1);
  };

  const isLastModal = currentIndex === selectedAssets.length - 1;

  const handleResolutionChange = (value) => {
    setSelectedResolutions((prev) =>
      prev.includes(value) ? prev.filter((res) => res !== value) : [...prev, value]
    );
  };

  return (
    <>
      {open && (
        <Modal key={currentIndex} open={open} size="tiny" centered>
          <Header icon>
            <Icon name="print" />
            StartPrint API
          </Header>
          <ModalContent className="model_content">
            {currentIndex === 0 && (
              <Message info icon="info circle" content={t("api_file_size_warning")} />
            )}
            <Form className="modal_form">
              <Header as="h4">{t("select_resolutions")}</Header>
              <Header as="h3" className="modal_subheader">
                {selectedAssets[currentIndex].name}
              </Header>
              <div>
                {resolutionOptions.map((option) => (
                  <Form.Field key={option.value}>
                    <Checkbox
                      label={`${option.value} [${option.label}]`}
                      checked={selectedResolutions.includes(option.value)}
                      onChange={() => handleResolutionChange(option.value)}
                    />
                  </Form.Field>
                ))}
              </div>
              <Form.Field key="pantone" className="modal_form_toggle">
                <Checkbox
                  fitted
                  label="Pantone Colors"
                  toggle
                  checked={isPantone}
                  onChange={() => setIsPantone(!isPantone)}
                />
              </Form.Field>
            </Form>
          </ModalContent>
          <ModalActions>
            <Button color="red" onClick={handleClose}>
              <Icon name="remove" /> {t("cancel")}
            </Button>
            {isLastModal ? (
              <Button
                color="green"
                onClick={() => handleSubmit(selectedAssets[currentIndex])}
                loading={isLoading}
                disabled={isLoading || selectedResolutions.length === 0}
              >
                <Icon name="checkmark" /> {t("submit")}
              </Button>
            ) : (
              <Button
                primary
                onClick={() => handleNext(selectedAssets[currentIndex])}
                disabled={selectedResolutions.length === 0}
              >
                <Icon name="right arrow" /> {t("next")}
              </Button>
            )}
          </ModalActions>
        </Modal>
      )}
    </>
  );
}

export default SendToStartPrintModal;
